export default __webpack_public_path__ + "static/N0202-b47588e07efed5ce82426e15b915117e.png";